module.exports = __webpack_public_path__ + "static/media/outfit-maison-margiela.9e48fe54.jpg";